<form nz-form [formGroup]="organizationForm" (ngSubmit)="submitForm()">
    <nz-form-item>
      <nz-form-label [nzSpan]="5" nzRequired nzFor="name">Name</nz-form-label>
      <nz-form-control   nzErrorTip="Please enter the organization name" nzHasFeedback>
        <input id="role" name="name" type="text" nz-input formControlName="name" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
        <nz-form-label [nzSpan]="5" nzFor="role">Email</nz-form-label>
        <nz-form-control   nzErrorTip="Please enter the email" nzHasFeedback>
          <input id="email" name="email" type="text" nz-input formControlName="email" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="5" nzFor="phone">Phone</nz-form-label>
        <nz-form-control   nzErrorTip="Please enter the Phone Number" nzHasFeedback>
          <input id="phone" name="phone" type="text" nz-input formControlName="phone" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="5"  nzFor="mobile">Mobile</nz-form-label>
        <nz-form-control>
          <input id="mobile" name="mobile" type="text" nz-input formControlName="mobile" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="5" nzFor="role">Address</nz-form-label>
        <nz-form-control   nzErrorTip="Please enter the address" nzHasFeedback>
          <input id="address" name="address" type="text" nz-input formControlName="address" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="5"  nzFor="city">City</nz-form-label>
        <nz-form-control   nzErrorTip="Please enter the city" nzHasFeedback>
          <input id="city" name="city" type="text" nz-input formControlName="city" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="5"  nzFor="country">Country</nz-form-label>
        <nz-form-control   nzErrorTip="Please enter the country" nzHasFeedback>
          <input id="country" name="country" type="text" nz-input formControlName="country" />
        </nz-form-control>
      </nz-form-item>

      
      <nz-form-item class="modal-footer-buttons">
            <button nz-button nzType="default" [nzSize]="'large'" type="button" (click)="handleCancel()">Cancel</button>
            <button nz-button nzType="primary"  class="succes-button" [nzSize]="'large'" [disabled]="disableSave()"  [nzLoading]="isLoading">Save</button>
      </nz-form-item>
  </form>